import styled from 'styled-components';
import { DialogTitle } from '@material-ui/core';

export const StyledDialogTitle = styled(DialogTitle)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 24px !important;
  .MuiTypography-h6 {
    margin-bottom: 0;
  }
`;
